<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：状态列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleStateSelect('')"
              :class="{ 'selected': queryStockManageInfo.conditions.state === '' }">
              全部
            </li>
            <li v-for="(item, index) in queryStockManageInfo.states" :key="index"
              @click="handleStateSelect(item.statusCd)"
              :class="{ 'selected': queryStockManageInfo.conditions.state === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <div class="">
            <el-form :inline="true" :model="queryStockManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input v-model="queryStockManageInfo.conditions.prodName" placeholder="请输入商品名称" clearable />
              </el-form-item>
              <el-form-item>
                <el-input v-model="queryStockManageInfo.conditions.productId" placeholder="请输入商品编号" clearable />
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="queryStockManageInfo.conditions.queryStartTime"
                  type="date"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="queryStockManageInfo.conditions.queryEndTime"
                  type="date"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_queryShopHouseMethod">
                  <i class="el-icon-search"></i> 查询
                </el-button>
                <el-button @click="_resetShopHouseMethod">
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 库存查询表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>库存查询</span>
          </div>
          <div class="">
            <el-table :data="queryStockManageInfo.inoutOrders" border style="width: 100%">
              <el-table-column prop="shName" label="仓库" align="center" />
              <el-table-column prop="prodName" label="商品名称" align="center" />
              <el-table-column prop="barCode" label="商品条码" align="center" />
              <el-table-column prop="specName" label="商品规格" align="center" />
              <el-table-column prop="unitName" label="商品单位" align="center" />
              <el-table-column prop="productId" label="商品编号" align="center" />
              <el-table-column prop="defaultSpecValue.stock" label="库存" align="center" />
              <el-table-column prop="inCount" label="进货次数" align="center" />
              <el-table-column prop="outCount" label="退货次数" align="center" />
              <el-table-column prop="inCount" label="将过期" align="center" />
              <el-table-column prop="outCount" label="耗损" align="center" />
              <el-table-column prop="stateName" label="状态" align="center" />
            </el-table>

            <el-pagination @current-change="handleCurrentChange" :current-page="queryStockManageInfo.conditions.page"
              :page-size="queryStockManageInfo.conditions.row" layout="total, prev, pager, next"
              :total="queryStockManageInfo.total" class="pagination" />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { listProductStock } from '@/api/goods/queryStockManageApi'

export default {
  name: 'QueryStockManage',
  data() {
    return {
      queryStockManageInfo: {
        inoutOrders: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          prodName: '',
          productId: '',
          state: '',
          shopId: '',
          queryStartTime: '',
          queryEndTime: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.shopId = getShopId()
    this.queryStockManageInfo.conditions.shopId = this.shopId
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      try {
        const {data} = await getDict('product', 'state')
        this.queryStockManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
      await this._listInoutOrder(1, 10)
    },
    async _listInoutOrder(page, rows) {
      this.queryStockManageInfo.conditions.page = page
      this.queryStockManageInfo.conditions.row = rows
      try {
        const res = await listProductStock(this.queryStockManageInfo.conditions)
        this.queryStockManageInfo.total = res.total
        this.queryStockManageInfo.records = res.records
        this.queryStockManageInfo.inoutOrders = res.data
      } catch (error) {
        console.error('请求失败处理:', error)
      }
    },
    _queryShopHouseMethod() {
      this._listInoutOrder(1, 10)
    },
    _resetShopHouseMethod() {
      this.queryStockManageInfo.conditions.prodName = ''
      this.queryStockManageInfo.conditions.productId = ''
      this.queryStockManageInfo.conditions.queryStartTime = ''
      this.queryStockManageInfo.conditions.queryEndTime = ''
      this._listInoutOrder(1, 10)
    },
    handleStateSelect(state) {
      this.queryStockManageInfo.conditions.state = state
      this.queryStockManageInfo.conditions.page = 1
      this._listInoutOrder(1, 10)
    },
    handleCurrentChange(val) {
      this._listInoutOrder(val, this.queryStockManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.margin-top-sm {
  margin-top: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>